<template>
  <form-button
    class="proposals-approved-button"
    :color="color"
    :href="parsed"
    :target="target"
    size="small"
    @click.native.stop
  >
    {{ text }}
  </form-button>
</template>

<script>
  import url from '@sdk/helpers/misc/formalization';

  import FormButton from '@cordel/components/Form/Button.vue';

  export default {
    name: 'ProposalsApprovedButton',
    components: {
      FormButton,
    },
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
      attempt: {
        type: Object,
        default() {
          return {};
        },
      },
      user: {
        type: Object,
        default() {
          return {};
        },
      },
      color: {
        type: String,
        default: undefined,
      },
      self: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      url() {
        return url(this.attempt);
      },

      parsed() {
        if (this.url) {
          return this.url;
        }

        return {
          name: 'proposals-read',
          params: {
            id: this.proposal.id,
          },
          hash: `#attempt-${this.attempt.id}`,
        };
      },

      text() {
        const { bank } = this.attempt;

        return bank ? `Faturar no ${bank.tradename || bank.name}` : 'Faturar';
      },

      target() {
        if (this.url || !this.self) {
          return '_blank';
        }

        return '_self';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  @include cordel-reset('.proposals-approved-button');

  .proposals-approved-button {
  }
</style>
